<script>
import { mapActions } from "pinia";
import { newsStore } from "@/store/newsStore";

export default {
  props: {
    news: {
      type: Object,
    },
  },
  methods: {
    ...mapActions(newsStore, ['updateConsolidatedNewsList']),
  },
};
</script>

<template>
  <div>
    {{$t('news.template.proposal.committeeDecisionConsolidated.p1')}}
    {{news.textParams[0]}}
    {{$t('news.template.proposal.committeeDecisionConsolidated.p2')}}
    <a
      class="consolidated-news"
      href="#"
      @click.prevent="updateConsolidatedNewsList(news.stringChildIds)"
    >
      {{$t('news.template.proposal.committeeDecisionConsolidated.p3')}}
    </a>!
  </div>
</template>
